import { db, functions } from '@/firebase'
import { createSlug } from "@/utils/utils.js";

export default {
  getPartners({ commit }) {
    return db.collection('partners').get()
      .then((snap) => {
        commit('setPartners', snap.docs.map(p => {
          return {
            ...p.data(),
            id: p.id
          }
        }))
      })
  },
  savePartner({ }, partner) {
    let id = partner.id;
    delete partner.id;
    if (id) {
      return db.collection('partners').doc(id).set(partner, { merge: true })
    } else {
      return db.collection('partners').doc(createSlug(partner.nombre)).set(partner)
    }
  },
  getPartnerGest({ commit, dispatch }, p) {
    return db.collection('partners').doc(p).get()
      .then(r => {
        if (r.exists) {
          let d = r.data();
          commit('app/setPartner', {
            id: r.id,
            nombre: d.nombre
          }, {
            root: true
          })
          commit('app/setPartnerNegocios', d.negocios, { root: true })
          dispatch('pedidos/getPedidosPartner', {}, { root: true })
        }
      })
  },
  getNegociosPartner({ rootState, commit }) {
    return Promise.all(rootState.app.partnerNegocios.map(n => {
      return db.collection('negocios').doc(n).get()
        .then(r => {
          if (r.exists) {
            return {
              ...r.data(),
              id: r.id
            }
          } else {
            return false;
          }
        })
    }))
      .then((r) => {
        commit('app/setPartnerNegocios', r.filter(n => !!n), { root: true })
      })

  },
  getFacturacion({ }, id) {
    return db.collection('partners').doc(id)
      .collection('secreto').doc('facturacion').get()
      .then((r) => {
        if (r.exists) {
          return r.data();
        }
      })
  },

}